import i18n from 'i18next';

// The x axis label a line chart draws under its plot ('' draws none).
// Cepstrum is drawn as a waveform chart, so it is told apart by its flag.
export const getXAxisLabel = ({ type, isCepstrum, expanded }) => {
  if (type === 'waveform') {
    if (isCepstrum) return i18n.t('common.charts.axis.quefrencyMs', { defaultValue: 'Quefrency (ms)' });
    return i18n.t('common.charts.axis.timeMs', { defaultValue: 'Time (ms)' });
  }
  if ((type === 'trend' || type === 'multiline') && expanded) {
    return i18n.t('common.date', { defaultValue: 'Date' });
  }
  return '';
};

export default getXAxisLabel;
